import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

import { sharedEmailWarning } from "./shared-email";

interface SharedEmailConfirmDialogProps {
  /** The family already using the address; `null` keeps the dialog closed. */
  familyName: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Asks before a second family of the claim is reached at an address another family already uses. */
export function SharedEmailConfirmDialog({ familyName, onConfirm, onCancel }: SharedEmailConfirmDialogProps) {
  return (
    <AlertDialog
      open={familyName !== null}
      onOpenChange={(open) => {
        if (!open) {
          onCancel();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Adresse mail déjà utilisée</AlertDialogTitle>
          <AlertDialogDescription>
            {familyName ? sharedEmailWarning(familyName) : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogClose render={<Button variant="outline" />}>Annuler</AlertDialogClose>
          <Button onClick={onConfirm}>Poursuivre</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
